import Button from '../../core/view/ui/Button';
import LayoutElement from '../../core/view/model/LayoutElement';
import {Circle, Ellipse, Polygon, Rectangle, RoundedRectangle, Text} from 'pixi.js';
import ValueText from '../../core/view/text/ValueText';
import LayoutBuilder from '../../core/utils/LayoutBuilder';
/* eslint-disable */
export default class BalanceInfo extends Button{

    private textCredit:Text;
    private textBet:Text;

    public tfCredit:ValueText;
    public tfBet:Text;
    constructor(le: LayoutElement, customClassResolver: (le: LayoutElement) => any = null, hitArea: Rectangle | Circle | Ellipse | Polygon | RoundedRectangle = null) {
        super(le, customClassResolver, hitArea);
        LayoutBuilder.create(le, this, (le: LayoutElement) => {
            return new ValueText(le);
        });

    }


}